import Vue from "vue"
import VueTelInput from "vue-tel-input"
import OtpInput from "@bachdgvn/vue-otp-input"
Vue.use(VueTelInput)
Vue.component("v-otp-input", OtpInput)
import "../registerServiceWorker"
import Login from "./Login.vue"
import "../app/styles/styles.scss"

import firebaseApp from "../firebase"
import { getAnalytics } from "firebase/analytics"
import { getMessaging } from "firebase/messaging"
Vue.prototype.$analytics = getAnalytics(firebaseApp)
if (process.env.NODE_ENV === "production") {
	Vue.prototype.$messaging = getMessaging(firebaseApp)
}

Vue.config.productionTip = false

new Vue({
	render: (h) => h(Login),
}).$mount("#app")
